import { combineReducers } from "redux";
import Countries from "./Countries";

const CountriesReducer = combineReducers({
  Countries,
});

export default CountriesReducer;
